import { render, staticRenderFns } from "./TheNotification.vue?vue&type=template&id=7ee27f59&"
import script from "./TheNotification.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TheNotification.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports